import useCurrentTenant from 'hooks/useCurrentTenant/useCurrentTenant';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import WizardModalTemplate, { WizardStep } from 'v2/components/WizardModal/WizardModalTemplate';
import AdminAccountCreatedStep from './modal/AdminAccountCreatedStep';
import CreateAccountStep from './modal/CreateAccountStep';
import VerifyAccountStep from './modal/VerifyAccountStep';

interface ConnectCognitoWizardProps {
  initialStep?: number;
}

const ConnectCognitoWizard: React.FC<ConnectCognitoWizardProps> = ({ initialStep = 0 }) => {
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });
  const { currentTenant } = useCurrentTenant({
    handleFetchError
  });

  const email =
    currentTenant?.onboardingStep === 'VerifyAccount' && currentTenant?.additionalData
      ? currentTenant?.additionalData
      : undefined;

  const stepsCognito: WizardStep[] = [{ label: 'Create account' }, { label: 'Verify' }, { label: 'Finish' }];

  return (
    <WizardModalTemplate title="Create account" steps={stepsCognito} initialStep={initialStep} hideCloseButton>
      <CreateAccountStep />
      <VerifyAccountStep email={email} />
      <AdminAccountCreatedStep />
    </WizardModalTemplate>
  );
};

export default ConnectCognitoWizard;
